'use strict';
module.exports = function (url) {
	if (typeof url !== 'string') {
		throw new TypeError('Expected a string');
	}

	return /^[a-z][a-z0-9+.-]*:/.test(url);
};



//////////////////
// WEBPACK FOOTER
// ./~/is-absolute-url/index.js
// module id = 3090
// module chunks = 0